exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3jWycu08m9_pGhm7f0U7mj{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3jWycu08m9_pGhm7f0U7mj,._3J0DlEF3-tXqehZJzmfbpa{color:\"[theme:neutralPrimary, default:#323130]\";white-space:nowrap;overflow:hidden;text-overflow:ellipsis}._3J0DlEF3-tXqehZJzmfbpa{font-size:12px;font-weight:400;display:block}", ""]);
// Exports
exports.locals = {
	"detail": "_3jWycu08m9_pGhm7f0U7mj",
	"detailText": "_3J0DlEF3-tXqehZJzmfbpa"
};